import { gql } from '@apollo/client';
import classnames from 'classnames';
import React, { ReactNode } from 'react';
import { When } from 'react-if';

import classes from '@nerdwallet/base-styles/classes';
import { Text } from '@nerdwallet/currency/components/Text';

import {
  CreditFactorInquirySection,
  CreditFactorTradelineSection,
} from '@generated-gql/generated-types';

import styles from './highlight-wrapper.module.scss';

interface Component<E> extends React.FC<E> {
  fragment: any;
}

interface Props {
  children?: ReactNode;
  section: CreditFactorTradelineSection | CreditFactorInquirySection;
}

const HighlightWrapper: Component<Props> = ({ children, section }) => (
  <li
    className={classnames(
      classes('padding-vertical-3'),
      classes('padding-horizontal-3'),
      {
        [classes('background-blue-lightest')]: section?.isPriority,
      },
    )}
  >
    <div className={classnames(styles.header)}>
      <When condition={!!section?.label}>
        <div className={styles.pill}>
          <Text tone="assist" size="small">
            {section?.label}
          </Text>
        </div>
      </When>

      <When condition={!!section?.title}>
        <Text size={section?.isPriority ? 'large' : 'default'} bold>
          {section?.title}
        </Text>
      </When>
    </div>

    {children}
  </li>
);

HighlightWrapper.fragment = gql`
  fragment highlightWrapperTradelineFragment on CreditFactorTradelineSection {
    isPriority
    label
    title
  }

  fragment highlightWrapperInquiryFragment on CreditFactorInquirySection {
    isPriority
    label
    title
  }
`;

export default HighlightWrapper;
